module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_vm._v("It’s Not About You, Mr. Easter Bunny")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "title1"
  }, [_vm._v("A Love Letter About the True Meaning of Easter")]), _vm._v(" "), _c('p', {
    staticClass: "aut"
  }, [_vm._v("Soraya Diase Coffelt")]), _vm._v(" "), _c('p', {
    staticClass: "aut1"
  }, [_vm._v("Illustrated by Tea Seroya")]), _vm._v(" "), _c('p', {
    staticClass: "aut2"
  }, [_c('i', [_vm._v("The Love Letters Book Series")])]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48901d5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title01.vue
// module id = 57
// module chunks = 0